export default __webpack_public_path__ + "static/media/chevron-left-black.a28ee7a4.svg";